export const SEVERITY_PATTERNS = [
  // Info
  'pattern-diagonal-stripes-xl',
  // Low
  'pattern-diagonal-stripes-lg',
  // Medium
  'pattern-diagonal-stripes-sm',
  // High
  'pattern-diagonal-stripes-xs',
  // Critical
  'pattern-diagonal-stripes-3px',
]
